import React from 'react';
import api from "../api";

const getStorage = async () => {
    try {
        const data = await api.get("Fabricantes/ObterTamanhoArmazenamento");
        return data;
    } catch (error) {
        return null;
    }
};

const getDetalheStorage = async () => {
    try {
        const data = await api.get("Fabricantes/ObterDetalheArmazenamento");
        return data;
    } catch (error) {
        return null;
    }
};

export {
   getStorage,
   getDetalheStorage,
};